/**
 * APIDefinition.js
 *
 * API definitions (sometimes referred to as API specifications or description
 * formats) are designed to provide a format for describing APIs that is
 * readable by machines. This file provides data oriented (pure) functions for
 * working with API definition objects.
 *
 * We use [Swagger](https://swagger.io/docs/specification/about/).
 *
 * Copyright (c) apploft. GmbH
 */

/**
 * Returns clone of `object`.
 *
 * @param {*} object JSON serializable object.
 */
function clone(object) {
  return JSON.parse(JSON.stringify(object));
} // eslint-disable-next-line no-shadow


function enable(_ref) {
  var api = _ref.api,
      keyAdminAuth = _ref.data.keyAdminAuth;
  api['2118265e-9625-40b9-864f-f5665637f3c2'] = keyAdminAuth;
  return api;
}

function keyAdminAuth(api) {
  return api['2118265e-9625-40b9-864f-f5665637f3c2'];
}

function url(path, api) {
  var host = api.host,
      basePath = api.basePath;
  return ['https://', host, basePath, path].join('');
}

function sections(api) {
  return clone(api.tags);
}
/**
 * Returns an Array of `api` paths matching `tag`.
 *
 * @param {*} tag The tag object you are interested in.
 * @param {{paths:*}} api The Swagger API definition object.
 */


function pathsMatching(tag, _ref2) {
  var paths = _ref2.paths;
  var acc = [];

  for (var _i = 0, _Object$keys = Object.keys(paths); _i < _Object$keys.length; _i++) {
    var name = _Object$keys[_i];
    var path = paths[name];
    var methods = Object.keys(path);

    for (var _i2 = 0, _methods = methods; _i2 < _methods.length; _i2++) {
      var method = _methods[_i2];
      var route = path[method];

      if (route.tags.indexOf(tag.name) === -1) {
        continue;
      } // Injecting contextual information


      route.pathID = {
        name: name,
        method: method
      };
      acc.push(route);
    }
  }

  return clone(acc);
}
/**
 * Returns `paths` matching `method`.
 *
 * @param {Array<object>} paths Array of path objects.
 * @param {string} method The HTTP method (lowercase or uppercase).
 */


function pathsByMethod(paths, method) {
  if (typeof method !== 'string') {
    return [];
  }

  return paths.filter(function (p) {
    return p.pathID.method === method.toLowerCase();
  });
}

export { keyAdminAuth, url, sections, pathsMatching, pathsByMethod, enable };